import { data } from '@amazon/vinyl-observable'
import { globalData } from '@amzn/bf-playback'

export const modalCount = globalData(() => data(0))
export const modalVisible = modalCount.map((v) => !!v)
export const modalVisibleClass$ = modalVisible.map((v) => (v ? 'modalVisible' : null))
